var _linearGradient, _polygon, _linearGradient2, _circle, _linearGradient3, _circle2, _linearGradient4, _path, _linearGradient5, _circle3, _linearGradient6, _circle4, _linearGradient7, _path2, _linearGradient8, _path3, _linearGradient9, _path4, _linearGradient0, _circle5, _circle6, _linearGradient1, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ManualHandling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "oenP9hw06nAyf_EoiU4msa",
    x1: 45.015,
    x2: 45.015,
    y1: -594.536,
    y2: -605.872,
    gradientTransform: "scale(-1) rotate(5.75 -5581.25 -946.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464eb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343b9e"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#oenP9hw06nAyf_EoiU4msa)",
    points: "15.349,35.076 17.544,42.752 20.682,42.179 19.289,32.593"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "oenP9hw06nAyf_EoiU4msb",
    x1: 43.556,
    x2: 43.556,
    y1: -594.269,
    y2: -605.826,
    gradientTransform: "scale(-1) rotate(5.75 -5581.25 -946.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464eb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343b9e"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.102,
    cy: 42.404,
    r: 1.596,
    fill: "url(#oenP9hw06nAyf_EoiU4msb)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "oenP9hw06nAyf_EoiU4msc",
    x1: 46.748,
    x2: 46.748,
    y1: -575.08,
    y2: -606.679,
    gradientTransform: "scale(-1) rotate(5.75 -5581.25 -946.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7179d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5961c3"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.885,
    cy: 32.558,
    r: 2.66,
    fill: "url(#oenP9hw06nAyf_EoiU4msc)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "oenP9hw06nAyf_EoiU4msd",
    x1: 27.194,
    x2: 39.758,
    y1: 16.551,
    y2: 29.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oenP9hw06nAyf_EoiU4msd)",
    d: "M28.216,17h10.805c0.552,0,1,0.448,1,1v9.951c0,0.552-0.448,1-1,1H28.216 c-0.552,0-1-0.448-1-1V18C27.216,17.448,27.664,17,28.216,17z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "oenP9hw06nAyf_EoiU4mse",
    x1: 46.216,
    x2: 46.216,
    y1: -575.08,
    y2: -606.679,
    gradientTransform: "scale(-1) rotate(5.75 -5581.25 -946.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7179d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5961c3"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.96,
    cy: 17.263,
    r: 4.255,
    fill: "url(#oenP9hw06nAyf_EoiU4mse)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "oenP9hw06nAyf_EoiU4msf",
    x1: 51.535,
    x2: 51.535,
    y1: -575.08,
    y2: -606.679,
    gradientTransform: "scale(-1) rotate(5.75 -5581.25 -946.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7179d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5961c3"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.708,
    cy: 26.256,
    r: 4.255,
    fill: "url(#oenP9hw06nAyf_EoiU4msf)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "oenP9hw06nAyf_EoiU4msg",
    x1: 48.907,
    x2: 48.907,
    y1: -575.08,
    y2: -606.679,
    gradientTransform: "scale(-1) rotate(5.75 -5581.25 -946.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7179d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5961c3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oenP9hw06nAyf_EoiU4msg)",
    d: "M15.961,29.001l6.661-9.575l-2.656-3.91l-4.532-0.637L8.97,24.222L15.961,29.001z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "oenP9hw06nAyf_EoiU4msh",
    x1: 39.625,
    x2: 39.625,
    y1: -575.677,
    y2: -605.494,
    gradientTransform: "scale(-1) rotate(5.75 -5581.25 -946.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7179d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5961c3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oenP9hw06nAyf_EoiU4msh)",
    d: "M22.386,22.963l-3.518-4.789c-0.75-1.404,3.907-2.796,3.907-2.796l2.769,5.27l6.327,1.123 l-0.32,3.175l-6.913-0.696C23.739,24.159,22.92,23.692,22.386,22.963z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "oenP9hw06nAyf_EoiU4msi",
    x1: 49.452,
    x2: 49.452,
    y1: -575.08,
    y2: -606.679,
    gradientTransform: "scale(-1) rotate(5.75 -5581.25 -946.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7179d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5961c3"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oenP9hw06nAyf_EoiU4msi)",
    d: "M18.875,34.323l0.378-2.973l-4.635-7.734l-4.944,5.626l3.841,3.866l-5.097,7.239l2.295,2.217 L18.875,34.323z"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "oenP9hw06nAyf_EoiU4msj",
    x1: 53.131,
    x2: 53.131,
    y1: -575.08,
    y2: -606.679,
    gradientTransform: "scale(-1) rotate(5.75 -5581.25 -946.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7179d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5961c3"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.575,
    cy: 41.444,
    r: 1.596,
    fill: "url(#oenP9hw06nAyf_EoiU4msj)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.671,
    cy: 23.35,
    r: 1.596,
    fill: "#6b73cd"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "oenP9hw06nAyf_EoiU4msk",
    x1: 39.216,
    x2: 45.786,
    y1: -566.963,
    y2: -573.534,
    gradientTransform: "scale(-1) rotate(5.75 -5581.25 -946.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oenP9hw06nAyf_EoiU4msk)",
    d: "M24.581,3.929c-2.342-0.236-4.427,1.47-4.662,3.807c-0.235,2.337,1.467,4.425,3.81,4.66 c2.337,0.235,4.423-1.471,4.658-3.808C28.622,6.252,26.919,4.165,24.581,3.929z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff8e6",
    d: "M35,19h-2.764v-2H35V19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ManualHandling);
export default __webpack_public_path__ + "static/media/icons8-manual-handling.71c7ee64fe2dfeb68b46057b925a6500.svg";
export { ForwardRef as ReactComponent };